module.exports = __webpack_public_path__ + "static/img/专密备案认定平台.82a545a3.png";